import React from "react"
import { Link } from "react-router-dom"

import "../styles/subterrafors.css"

const SubterraForsPrivacy = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  document.title = "Privacy Policy | Subterra Fors"

  return (
    <div className="subterrafors-page">
      <div className="sf-privacy-page">
        <Link to="/subterrafors" className="sf-privacy-back">
          ← Subterra Fors
        </Link>

        <p className="sf-privacy-effective">Effective when the app is released</p>
        <h1 className="sf-section-title sf-privacy-title">
          Subterra Fors Privacy Policy
        </h1>

        <p className="sf-privacy-p">
          Welcome! This privacy policy explains how Bubbly Studios handles
          information for this app.
        </p>

        <h2 className="sf-privacy-h2">Overview</h2>
        <p className="sf-privacy-p">
          Bubbly Studios respects your privacy. This app does not collect,
          store, process, or share any personal data from users.
        </p>
        <p className="sf-privacy-p">
          You can use the app without creating an account, providing personal
          information, or being tracked.
        </p>

        <h2 className="sf-privacy-h2">Information we do not collect</h2>
        <p className="sf-privacy-p">This app does not collect:</p>
        <ul className="sf-privacy-list">
          <li>Personal identifiers (name, email address, username, date of birth)</li>
          <li>Location data</li>
          <li>Usage analytics or behavioral data</li>
          <li>Device identifiers (IP address, device ID)</li>
          <li>Cookies or tracking technologies</li>
          <li>Payment or purchase information</li>
          <li>User-generated content stored on our servers</li>
        </ul>
        <p className="sf-privacy-p">
          All functionality of the app runs locally on your device.
        </p>

        <h2 className="sf-privacy-h2">Payments and legal compliance</h2>
        <p className="sf-privacy-p">
          If we ever offer in-app purchases, the transaction would be handled
          by the platform (e.g. Apple App Store or Google Play). We would not
          receive or store your payment details. We may disclose information when
          required by law (e.g. court order or lawful request).
        </p>

        <h2 className="sf-privacy-h2">Third-party services</h2>
        <p className="sf-privacy-p">
          This app does not integrate with third-party analytics, advertising
          networks, or data brokers. We do not use crash reporting or other
          tracking services.
        </p>
        <p className="sf-privacy-p">
          If you download the app through an app store (such as Apple App Store
          or Google Play), those platforms may collect data independently
          according to their own privacy policies. Bubbly Studios does not
          receive or control that data.
        </p>

        <h2 className="sf-privacy-h2">Data storage</h2>
        <p className="sf-privacy-p">
          Bubbly Studios does not store any user data on external servers for
          this app.
        </p>
        <p className="sf-privacy-p">
          Any preferences or content created within the app remain on your
          device and are managed by your operating system.
        </p>

        <h2 className="sf-privacy-h2">Children’s privacy</h2>
        <p className="sf-privacy-p">
          Because this app does not collect personal data, it does not
          knowingly collect information from children under 13.
        </p>

        <h2 className="sf-privacy-h2">Changes to this policy</h2>
        <p className="sf-privacy-p">
          If the app’s functionality changes in a way that involves data
          collection, this privacy policy will be updated before those changes
          take effect.
        </p>
        <p className="sf-privacy-p">
          The effective date at the top of this document reflects the latest
          version.
        </p>

        <h2 className="sf-privacy-h2">Contact us</h2>
        <p className="sf-privacy-p">
          If you have questions about this privacy policy, you can contact us
          at:{" "}
          <a
            href="mailto:contact@bubblystudios.com"
            className="sf-privacy-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            contact@bubblystudios.com
          </a>
        </p>

        <p className="sf-privacy-p sf-privacy-footer">
          © {new Date().getFullYear()} Bubbly Studios
        </p>
      </div>
    </div>
  )
}

export default SubterraForsPrivacy
